import PermissionHide from 'components/PermissionHide';
import React, { Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';

import type { RouteProps } from 'react-router-dom';

interface IProps extends RouteProps {
  action?: string | string[];
}

export default class PermissionRoute extends Route<IProps> {
  render() {
    return (
      <Fragment>
        <PermissionHide action={this.props.action}>{super.render()}</PermissionHide>
        <PermissionHide inverse action={this.props.action}>
          <Redirect to='/' />
        </PermissionHide>
      </Fragment>
    );
  }
}
